import { defineMessages } from 'react-intl-next';

import type { i18nType } from '../../../../../common/types';

type CloseDateLabelsType = Record<string, i18nType>;

export const closeDateLabels: CloseDateLabelsType = defineMessages({
	anytime: {
		id: 'search-page.filter.close.date.anytime',
		defaultMessage: 'Anytime',
		description: 'Close date filter anytime option label',
	},
	today: {
		id: 'search-page.filter.close.date.today',
		defaultMessage: 'Today',
		description: 'Close date filter today option label',
	},
	last7days: {
		id: 'search-page.filter.close.date.last7days',
		defaultMessage: 'Last 7 days',
		description: 'Close date filter last 7 days option label',
	},
	last30days: {
		id: 'search-page.filter.close.date.last30days',
		defaultMessage: 'Last 30 days',
		description: 'Close date filter last 30 days option label',
	},
	last90days: {
		id: 'search-page.filter.close.date.last90days',
		defaultMessage: 'Last 90 days',
		description: 'Close date filter last 90 days option label',
	},
	last365days: {
		id: 'search-page.filter.close.date.last365days',
		defaultMessage: 'Last 365 days',
		description: 'Close date filter last 365 days option label',
	},
	next7days: {
		id: 'search-page.filter.close.date.next7days',
		defaultMessage: 'Next 7 days',
		description: 'Close date filter next 7 days option label',
	},
	next30days: {
		id: 'search-page.filter.close.date.next30days',
		defaultMessage: 'Next 30 days',
		description: 'Close date filter next 30 days option label',
	},
	next90days: {
		id: 'search-page.filter.close.date.next90days',
		defaultMessage: 'Next 90 days',
		description: 'Close date filter next 90 days option label',
	},
	next365days: {
		id: 'search-page.filter.close.date.next365days',
		defaultMessage: 'Next 365 days',
		description: 'Close date filter next 365 days option label',
	},
	custom: {
		id: 'search-page.filter.close.date.custom',
		defaultMessage: 'Specific date',
		description: 'Close date filter specific date option label',
	},
});
